import { css, useTheme } from '@emotion/react';
import { Box, Link, Stack } from '@mui/material';
import { ScorencoLogo } from '@scorenco/components';
import { useTranslation } from '@scorenco/core';

import { T_KEYS } from '@/translations';

const style = {
  root: () => css`
    width: 100%;
    text-decoration: none;

    .snc-logo {
      height: 1.25rem;
      width: auto;
    }
  `,
};

type LiveWidgetTitleProps = { status?: string };

export const LiveWidgetTitle = ({ status }: LiveWidgetTitleProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Link
      // href="https://scorenco.com"
      // target="_blank"
      css={style.root}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          width: '100%',
          color: theme.vars.palette.primary.main,
          pl: '1rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Stack
          direction="row"
          spacing={0.8}
          sx={{
            fontWeight: 700,
            textTransform: 'uppercase',
            fontSize: '0.75rem',
            alignItems: 'center',
            py: '0.5rem',
          }}
        >
          <Box
            component="span"
            sx={{
              width: '1rem',
              height: '1rem',
              backgroundColor: theme.vars.palette.error.main,
              borderRadius: '999rem',
              mr: 1,
            }}
          />
          {t(T_KEYS.LIVE_WITH)} <ScorencoLogo className="snc-logo" />
        </Stack>
        {(status === 'live' ||
          status === 'finish' ||
          status === 'postponed' ||
          status === 'withdrawal' ||
          status === 'to_come') && (
          <Box
            component="span"
            sx={{
              fontWeight: 700,
              textTransform: 'uppercase',
              fontSize: '1rem',
              alignItems: 'center',
              px: '1rem',
              py: '0.5rem',
              backgroundColor: theme.vars.palette.secondary.main,
              color: theme.vars.palette.secondary.contrastText,
            }}
          >
            {status === 'finish' && t(T_KEYS.EVENT_FINISH)}
            {status === 'postponed' && t(T_KEYS.EVENT_POSTPONED)}
            {status === 'withdrawal' && t(T_KEYS.EVENT_WITHDRAWAL)}
            {status === 'live' && t(T_KEYS.EVENT_LIVE)}
            {status === 'to_come' && t(T_KEYS.EVENT_TO_COME)}
          </Box>
        )}
      </Box>
    </Link>
  );
};
